import { TElement } from './types';

function getSliderByType(element: HTMLElement, type: TElement): HTMLElement {
  if (type === 'button-send' || type === 'more-info') {
    return element.parentElement as HTMLElement;
  }

  return element;
}

export const isCardVisible = (
  slider: HTMLElement,
  card: HTMLElement,
): boolean => {
  const slice = {
    initial: slider.getBoundingClientRect().left,
    end: slider.getBoundingClientRect().right,
  };

  const { left, right } = card.getBoundingClientRect();
  const isVisibleOnMarginLeft = left >= slice.initial;
  const isVisibleOnMarginRight = right <= slice.end;

  return isVisibleOnMarginLeft && isVisibleOnMarginRight;
};

export function getVisibleCardsIdByElement(
  element: HTMLElement,
  type: TElement,
  target = '.vitrine-template1__card',
): string[] {
  const slider = getSliderByType(element, type);
  const cards = slider.querySelectorAll(target);
  const visibleCards: string[] = [];

  cards.forEach(card => {
    if (isCardVisible(slider, card as HTMLElement)) {
      const cardId = card.getAttribute('data-id');
      if (cardId) {
        visibleCards.push(cardId);
      }
    }
  });

  return visibleCards;
}
